module.exports = __webpack_public_path__ + "img/032-zambia.b475659b.svg";